<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title">QUILTS<br/><span class="subtitle">From Tilda’s Studio</span></h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?1e2b32fa